export function consoleStringify(data: any) {
  console.log(JSON.stringify(data, null, 2));
}
